<div class="input-div">
  <input #input (focus)="selectText()" (keyup)="onKeyUp($event)" [(ngModel)]="currentValue"
         [disabled]="params?.data?._tags?.includes('disabled') && !params?.context?.isStockManager"/>

    @if (isCurrentValueEdited()) {
      <app-display-icon
        (click)="onUndoChangesClick()"
        [icon]="icons.backSpaceOutline">
      </app-display-icon>
    }
  </div>
